import { createContext, useReducer } from 'react';
import UserReducer from './UserReducer';  

const storedUser = localStorage.getItem('user');

export const initialState = {
  user: storedUser ? JSON.parse(storedUser) : null,
  token: localStorage.getItem('token') || null,
  role: storedUser && JSON.parse(storedUser)?.role ? JSON.parse(storedUser).role : null,
  firstLogin: { tmpToken: null, tmpUser: null, isFirstLogin: false },
  status: '',
  errorMessage: '',
  errorStatus: null,
};

const UserContext = createContext(initialState);

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(UserReducer, initialState);

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
